import { ICalculatedPlanning } from 'volta/models/types/planning';

import { htmlSafe } from '@ember/template';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';

interface IArgs {
  realBuffer?: ICalculatedPlanning;
  simulatedBuffer?: ICalculatedPlanning;
  fixedRedBase?: boolean;
  fixedRedSafety?: boolean;
  fixedYellow?: boolean;
  fixedGreen?: boolean;
}

export default class BufferSimulation extends Component<IArgs> {
  get realStock() {
    return this.args.realBuffer?.buffer.topOfGreen ?? 0;
  }

  get simulatedStock() {
    return this.args.simulatedBuffer?.buffer.topOfGreen ?? 0;
  }

  get isDDMRP() {
    return this.args.realBuffer?.methodology === 'BUFFER';
  }

  get hasBuffer() {
    return isPresent(this.args.realBuffer) || isPresent(this.args.simulatedBuffer);
  }

  get realReorderFrequency() {
    const adu = Math.abs(this.args.realBuffer?.adu ?? 0);
    const green = this.args.realBuffer?.buffer.green ?? 0;
    return adu === 0 ? 0 : Math.ceil(green / adu);
  }

  get simulatedReorderFrequency() {
    const adu = Math.abs(this.args.simulatedBuffer?.adu ?? 0);
    const green = this.args.simulatedBuffer?.buffer.green ?? 0;
    return adu === 0 ? 0 : Math.ceil(green / adu);
  }

  get realBufferStyle() {
    const realStock = this.realStock;
    const simulatedStock = this.simulatedStock;
    const ratio =
      realStock >= simulatedStock ? 1 : simulatedStock !== 0 ? realStock / simulatedStock : 1;
    return htmlSafe(
      'height:100%; transform: scaleY(' + (ratio !== 0 ? ratio : 1) + '); transform-origin: bottom'
    );
  }

  get simulatedBufferStyle() {
    const realStock = this.realStock;
    const simulatedStock = this.simulatedStock;
    const ratio =
      simulatedStock >= realStock ? 1 : realStock !== 0 ? simulatedStock / realStock : 1;
    return htmlSafe(
      'height:100%; transform: scaleY(' + (ratio !== 0 ? ratio : 1) + '); transform-origin: bottom'
    );
  }
}
